module.exports = "/_next/static/images/TopDestinationCategories-d097919541fb83b0a63c5897de49df46.png";